import { useEffect, useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { supabase } from "../lib/supabaseClient";
import { useAuth } from "../contexts/AuthContext";
import { useCreditBalance } from "../hooks/useCreditBalance";

export default function GlobalHeaderButtons() {
  const { user } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;
  const { balance } = useCreditBalance();

  const isLanding = pathname === "/" || pathname.startsWith("/landing");
  const isResetPassword = pathname === "/reset-password";
  const isDashboard = pathname === "/dashboard";

  const [profile, setProfile] = useState<{ id: string; role: string | null } | null>(null);

  useEffect(() => {
    if (!user) {
      setProfile(null);
      return;
    }

    let isCancelled = false;

    const fetchProfile = async () => {
      const { data, error } = await supabase
        .from("profiles")
        .select("id, role")
        .eq("id", user.id)
        .single();

      if (error) {
        console.error("Fehler beim Laden des Profils:", error.message);
        if (!isCancelled) setProfile(null);
        return;
      }

      if (!isCancelled) setProfile(data);
    };

    fetchProfile();

    return () => {
      isCancelled = true;
    };
  }, [user]);

  if (!user || isLanding || isResetPassword) return null;

  return (
    <>
      {/* Admin-Button (fix RECHTS OBEN, nur für Admins) */}
      {profile?.role === "admin" && (
        <div className="fixed top-4 right-4 z-50">
          <Link
            to="/admin"
            className="bg-red-600 text-white hover:bg-red-700 rounded-full px-3 py-2 text-sm flex items-center gap-1 shadow transition-colors"
            title="Admin-Bereich"
          >
            🛠️ <span className="hidden sm:inline">Admin</span>
          </Link>
        </div>
      )}

      {/* Home-Button (fix LINKS OBEN, wenn nicht auf Dashboard) */}
      {!isDashboard && (
        <div className="fixed top-4 left-4 z-50">
          <Link
            to="/dashboard"
            className="bg-[#161b27] border border-[#2a3347] text-slate-300 hover:bg-[#1e2639] hover:text-slate-100 rounded-full px-3 py-2 text-sm flex items-center gap-1 shadow-lg transition-colors"
            title="Dashboard"
          >
            🏠 <span className="hidden sm:inline">Dashboard</span>
          </Link>
        </div>
      )}

      {/* SC-Balance (fix oben mittig) */}
      {balance !== null && (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-50">
          <Link
            to="/profile"
            className="bg-[#161b27] border border-[#2a3347] rounded-full px-3 py-2 shadow-lg hover:bg-[#1e2639] transition-colors flex items-center gap-1.5"
            title="Svevana Credits"
          >
            <span className="text-[11px] text-slate-400">✨</span>
            <span className="text-[11px] font-medium text-slate-300">{balance} SC</span>
          </Link>
        </div>
      )}
    </>
  );
}
